import Minidrawer from 'components/GlobalModals/ProductSamplesModal/Minidrawer/Minidrawer';
import { withMinidrawerProps } from 'viewModel/samples/minidrawer/withMinidrawerProps';

export default withMinidrawerProps(Minidrawer);
